import { useContext } from 'react';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import useIsVdpCoreDataLoaded from '~/hooks/vdp/selectors/useIsVdpCoreDataLoaded';
import useShouldLoadBelowFirstSectionStandard from './useShouldLoadBelowFirstSectionStandard';

export default function useShouldLoadRecommendedVehiclesSection(): boolean {
  const showComposerTreatment = useShowComposerTreatment();
  const shouldLoadBelowFirstSection = useShouldLoadBelowFirstSectionStandard();
  const { spinnerReady } = useContext(SpinnerContext);
  const isVdpCoreDataLoaded = useIsVdpCoreDataLoaded();

  if (!showComposerTreatment) {
    return shouldLoadBelowFirstSection;
  }

  const isEarlyReady = Boolean(spinnerReady.isLoaded && isVdpCoreDataLoaded);

  return isEarlyReady || shouldLoadBelowFirstSection;
}
